import { createEpic } from "../helpers";

import {
	getListAsyncAction,
	postManyAsyncAction,
	truncateAsyncAction,
} from "./instagramActions";

export const getInstagramListEpic = createEpic(
	getListAsyncAction,
	"instagram",
	"getList",
	true
);

export const postInstagramManyEpic = createEpic(
	postManyAsyncAction,
	"instagram",
	"postMany",
	true
);

export const truncateInstagramEpic = createEpic(
	truncateAsyncAction,
	"instagram",
	"truncate",
	true
);
